import { useState, useEffect } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useSimulatorData = (getAuthHeaders, setFormData) => {
  const [equipment, setEquipment] = useState([]);
  const [licenses, setLicenses] = useState([]);
  const [clientSpecialFees, setClientSpecialFees] = useState([]);
  const [clients, setClients] = useState([]);
  const [irsYouthConfig, setIrsYouthConfig] = useState(null);
  const [benefitSettings, setBenefitSettings] = useState(null);
  const [customBenefits, setCustomBenefits] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [jobFunctions, setJobFunctions] = useState([]);

  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    try {
      const [equipmentRes, licensesRes, clientFeesRes, irsYouthRes, benefitRes, customBenefitsRes, templatesRes, jobFunctionsRes, intlRes, clientsRes] = await Promise.all([
        axios.get(`${API}/equipment`, { headers: getAuthHeaders() }),
        axios.get(`${API}/licenses`, { headers: getAuthHeaders() }).catch(() => ({ data: [] })),
        axios.get(`${API}/client-special-fees`, { headers: getAuthHeaders() }).catch(() => ({ data: [] })),
        axios.get(`${API}/irs-jovem/active`, { headers: getAuthHeaders() }),
        axios.get(`${API}/benefit-settings`, { headers: getAuthHeaders() }),
        axios.get(`${API}/custom-benefits`, { headers: getAuthHeaders() }),
        // NOTA: `/simulator-layout` foi REMOVIDO daqui — o `useEffectiveLayout` em
        // `SimulatorPresets.jsx` já trata disso com o parâmetro `view` (evita chamada duplicada).
        axios.get(`${API}/templates`, { headers: getAuthHeaders() }).catch(() => ({ data: [] })),
        axios.get(`${API}/job-functions`, { headers: getAuthHeaders() }).catch(() => ({ data: [] })),
        axios.get(`${API}/international-costs`, { headers: getAuthHeaders() }).catch(() => ({ data: {} })),
        axios.get(`${API}/clients?active_only=true`, { headers: getAuthHeaders() }).catch(() => ({ data: [] })),
      ]);
      setEquipment(equipmentRes.data);
      setLicenses(licensesRes.data || []);
      setClientSpecialFees(clientFeesRes.data || []);
      setClients(clientsRes.data || []);
      setIrsYouthConfig(irsYouthRes.data);
      // Merge benefit settings with international defaults so widgets can read both
      setBenefitSettings({ ...benefitRes.data, ...(intlRes.data || {}) });
      setCustomBenefits(customBenefitsRes.data);
      setTemplates(templatesRes.data || []);
      setJobFunctions(jobFunctionsRes.data || []);

      if (benefitRes.data?.meal_card_limit) {
        setFormData(prev => ({ ...prev, meal_allowance_daily: benefitRes.data.meal_card_limit }));
      }
    } catch (error) {
      console.error("Error loading initial data:", error);
    }
  };

  return {
    equipment, licenses, clientSpecialFees, clients, irsYouthConfig, benefitSettings, customBenefits,
    templates, setTemplates,
    jobFunctions,
  };
};
